<template>
  <v-form ref="form" v-model="valid" lazy-validation class="catalogo-form">
    <v-row align="center" class="catalogo-row">
      <v-card class="catalogo-card"><v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          v-if="tableOptions.itemsPerPage !== -1"
          :headers="headers"
          :items="filteredList"
          :loading="loading"
          loading-text="Buscando dados..."
          class="elevation-1"
          :options.sync="tableOptions"
          :footer-props="{
            showFirstLastPage: true,
            itemsPerPageText: 'Items por página',
            itemsPerPageOptions: [5, 10, 15, 50, 100, -1],
          }"
        >
          <template v-slot:item.quantidade="{ item }">
            <v-text-field
              v-model="item.quantidade"
              type="number"
              v-mask="['#####']"
            >
            </v-text-field>
          </template>
          <template v-slot:item.codigo="{ item }">
            {{ item.codigo === null || item.codigo === '' ? "NA" : item.codigo }}
          </template>
          <template v-slot:item.observacao="{ item }">
            <v-text-field v-model="item.observacao" v-uppercase maxlength="500" counter>
            </v-text-field>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="info"
                  fab
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="addProduto(item)"
                  class="white--text"
                >
                  <v-icon> mdi-plus </v-icon>
                </v-btn>
              </template>
              <span>Adicionar produto</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <catalogo-virtual-table
          v-else
          :headers="headers"
          :items="filteredList"
          :loading="loading"
          :items-per-page.sync="tableOptions.itemsPerPage"
          item-key="id"
        >
          <template v-slot:item.descricao="{ item }">
            <span class="catalogo-descricao" :title="item.descricao">
              {{ item.descricao }}
            </span>
          </template>
          <template v-slot:item.codigo="{ item }">
            {{ item.codigo === null || item.codigo === "" ? "NA" : item.codigo }}
          </template>
          <template v-slot:item.quantidade="{ item }">
            <v-text-field
              v-model="item.quantidade"
              hide-details
              type="number"
              v-mask="['#####']"
            >
            </v-text-field>
          </template>
          <template v-slot:item.observacao="{ item }">
            <v-text-field v-model="item.observacao" v-uppercase hide-details maxlength="500">
            </v-text-field>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="info"
                  fab
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="addProduto(item)"
                  class="white--text"
                >
                  <v-icon> mdi-plus </v-icon>
                </v-btn>
              </template>
              <span>Adicionar produto</span>
            </v-tooltip>
          </template>
        </catalogo-virtual-table>
      </v-card>
    </v-row>
    <v-snackbar v-model="errorMessage" color="error" timeout="3000"
      >Informe a quantidade!
    </v-snackbar>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import CatalogoVirtualTable from "../Shared/CatalogoVirtualTable.vue";

export default {
  name: "servico",
  components: {
    CatalogoVirtualTable,
  },
  data: () => ({
    search: "",
    valid: true,
    errorMessage: false,
    tableOptions: {
      itemsPerPage: 10,
    },
    headers: [
      { text: "Id", value: "id", sortable: true },
      { text: "Item", value: "descricao", sortable: true },
      { text: "Cod. Fabricante", value: "codigo", sortable: true },
      { text: "Und.", value: "unidadeMedida", sortable: true },
      {
        text: "Quantidade",
        value: "quantidade",
        sortable: false,
        width: "10%",
      },
      { text: "Detalhamento", value: "observacao", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  props: {
    produtosL: Array,
    showModal: Boolean,
  },
  computed: {
    ...mapGetters("produto", { listaServicos: "servicosExternos" }),
    filteredList() {
      return this.listaServicos.filter((p) => {
        return (
          (p.id.toString().toLowerCase().includes(this.search.toLowerCase()) ||
            (p.descricao || "")
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            (p.codigo || "")
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            (p.unidadeMedida || "")
              .toLowerCase()
              .includes(this.search.toLowerCase())) &&
          p.ativo === true
        );
      });
    },
    loading() {
      return !(this.listaServicos != null && this.listaServicos.length > 0);
    },
  },
  methods: {
    updateObjectEstate() {
      return this.$refs.form.validate();
    },

    clear() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.resetQuantidades();
    },

    resetQuantidades() {
      (this.listaServicos || []).forEach((servico) => {
        this.$set(servico, "quantidade", null);
        this.$set(servico, "observacao", null);
      });
    },

    addProduto: function (p) {
      if (p.quantidade > 0) {
        var produto = new Object();
        produto.idProduto = p.id;
        produto.descricao = p.descricao;
        produto.codigo = p.codigo;
        produto.unidadeMedida = p.unidadeMedida;
        produto.quantidade = p.quantidade;
        produto.idCentroCusto = 0;
        produto.centroCusto = null;
        produto.observacao = p.observacao;
        produto.centroCustoErro = false;
        produto.editingCentroCusto = false;
        produto.index =
          this.produtosL.length === 0
            ? 0
            : this.produtosL[this.produtosL.length - 1].index + 1;

        this.produtosL.push(JSON.parse(JSON.stringify(produto)));
        this.$set(p, "quantidade", null);
        this.$set(p, "observacao", null);
      } else {
        this.errorMessage = true;
      }
    },
  },
  watch: {
    showModal() {
      this.resetQuantidades();
      this.search = "";
      this.errorMessage = false;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
  },
};
</script>

<style scoped>
.catalogo-form,
.catalogo-row,
.catalogo-card {
  box-sizing: border-box;
  max-width: 100%;
  min-width: 0;
  width: 100%;
}

.catalogo-card {
  align-self: stretch;
  flex: 1 1 auto;
}

.catalogo-descricao {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 1.35;
  overflow: hidden;
  overflow-wrap: anywhere;
  white-space: normal;
  word-break: normal;
}
</style>
